<template>
  <div class="doorpost-banner">
    <img :src="epbanner" alt="" />
    <div class="absolute">
      <div class="title">智慧防疫</div>
      <div class="text">
        畅月数字家园以科技力量全方位赋能疫情防控工作，借助大数据、人工 智能、互联网等新一代信息技术，在疫情防范控制、民生保障方面做出努力。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import epbanner from "../../../../assets/programme/epbanner.png";

export default {
  setup() {
    return reactive({
      epbanner: epbanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.doorpost-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .doorpost-banner {
    min-width: 1180px;
  }
}
.doorpost-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
